import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { endpoint } from "../../common/constant";
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import TemplateMappingHeader from "./templateMappingHeader";
import TemplateListing from "./templateList";
import CustomButton from "../../../../../components/CustomButton";
import { putpost } from "services/http";
import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";
import CommonInput from "../../common/formFeilds/input/commonInput";
import TemplateListingView from "./viewList";
import "./index.css";

const emplySearchParams = {
  templateId: "",
  templateName: "",
  channel: "",
  templateCategoryId: "",
};
const emptyPagination = {
  currentPage: 1,
  nextPage: null,
  previousPage: null,
  totalPage: null,
};
const pageSize = 10;

const TemplateMapping = () => {
  const [values, setValues] = useState({
    project: "",
    roleId: "",
    destinationType: "",
  });

  const [projectData, setProjectData] = useState({ fetching: true, data: [] });

  const [selectedIds, setSelectedIds] = useState([]);
  const [isAllSelected, setAllSelected] = useState(false);
  const [deselectedIds, setDeselectedIs] = useState([]);
  const [isSaving, setSaving] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [disableHeader, setDisableHeader] = useState(false);
  const [searchParams, setSearchParms] = useState(emplySearchParams);
  const [havePreviousRecord, setHavePreviousRecord] = useState({
    completed: false,
    haveData: false,
  });
  const [destinationTypeData, setDestinationTypeData] = useState({
    fetching: true,
    data: [],
  });
  const [selectedMethod, setSelectedMethod] = useState("templateList");
  const [roleData, setRoleData] = useState({ fetching: false, data: [] });
  const [existingRoles, setExistingRoles] = useState([]);
  const [rolesIds, setRoleIds] = useState([]);
  const [serverData, setServerData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [pagination, setpagination] = useState(emptyPagination);
  const [messageTemplateList, setMessageTemplateList] = useState([]);

  const getProject = async () => {
    const project = await fetchAllPromisedData(
      endpoint.projectDetails.getAllActiveProject,
      false
    );
    if (Array.isArray(project)) {
      const tempData = project?.map((p) => {
        return { label: p.projectDispValue, value: p.id };
      });
      setProjectData({ fetching: false, data: tempData });
    } else {
      setProjectData({ fetching: false, data: [] });
    }
  };

  const getDestinationType = async () => {
    const destinationType = await fetchAllPromisedData(
      endpoint.destinationType.getAll,
      false
    );
    if (Array.isArray(destinationType)) {
      const tempData = destinationType?.map((p) => {
        return { label: p.notiDestType, value: p.id };
      });
      setDestinationTypeData({ fetching: false, data: tempData });
    } else {
      setDestinationTypeData({ fetching: false, data: [] });
    }
  };

  const validateProjectAndRole = async () => {
    setExistingRoles([]);
    setSelectedMethod("templateList");
    resetAll();
    setFetching(true);
    const templates = await fetchAllPromisedData(
      `${endpoint.getTemplatesByRole}/${values.roleId?.value}`,
      true
    );
    if (templates?.code === 200) {
      if (templates.data?.[0]?.templateId === "ALL") {
        setAllSelected(true);
      } else {
        const tempArr = templates.data.map((item) => Number(item.templateId));
        setSelectedIds(tempArr);
      }
      setFetching(true);
      setDisableHeader(true);
    } else {
      setFetching(true);
    }
  };

  const reset = () => {
    setValues({
      project: "",
      roleId: "",
    });
    setSelectedIds([]);
    setAllSelected(false);
    setDeselectedIs([]);
    setSaving(false);
    setFetching(false);
    setDisableHeader(false);
    setHavePreviousRecord({ completed: false, haveData: false });
    setDisableHeader(false);
  };

  const handleMapping = () => {
    if (!isAllSelected && !selectedIds?.length) {
      failureToast("Please select atleast one template.");
      return;
    }

    const request = {
      roleId: values?.roleId?.value,
      // "": values?.
      selectedTemplates: selectedIds,
      deselectedTemplates: deselectedIds,
      searchFilter: {
        ...searchParams,
        channel: searchParams.channel?.value ?? "",
        templateCategoryId: searchParams.templateCategoryId?.value ?? "",
      },
      isAllSelected: isAllSelected,
    };

    putpost(
      endpoint.updateMapping,
      (data) => {
        if (data?.code == 200) {
          successToast(data.message);
          reset();
        }
      },
      (data) => {
        failureToast(data["message"]);
      },
      request,
      "post"
    );
  };

  // useEffect(()=>{
  //   if(values.roleId?.value){
  //     validateProjectAndRole();
  //   }
  // },[values.roleId])

  useEffect(() => {
    getProject();
    getDestinationType();
  }, []);
  const handleSelectChannelToTest = (key) => {
    resetAll();
    setSelectedMethod(key);
  };
  const resetAll = () => {
    setRoleIds([]);
    setServerData([]);
    setTableData([]);
    setMessageTemplateList([]);
    setpagination(emptyPagination);
  };
  const viewExistingRolesData = async (existingRole) => {
    resetAll();
    let nn = existingRoles.map((el) => el.value);
    setRoleIds(nn);
  };
  const saveExistingRolesData = (existingRole) => {
    let nn = existingRoles.map((el) => el.value);
    const request = {
      roleId: values?.roleId?.value,
      selectedRoles: nn,
    };

    putpost(
      endpoint.updateRoleMapping,
      (data) => {
        if (data?.code == 200) {
          successToast(data.message);
          reset();
        }
      },
      (data) => {
        failureToast(data["message"]);
      },
      request,
      "post"
    );
  };
  const handleExistingRoleSelectOnFocus = () => {
    console.log(tableData, pagination);
  };

  return (
    <>
      <Container fluid>
        <Card>
          <TemplateMappingHeader
            roleData={roleData}
            setRoleData={setRoleData}
            values={values}
            setValues={setValues}
            projectData={projectData}
            disableHeader={disableHeader}
            fetching={fetching}
            validateProjectAndRole={validateProjectAndRole}
            havePreviousRecord={havePreviousRecord}
            destinationTypeData={destinationTypeData}
            setHavePreviousRecord={setHavePreviousRecord}
            selectedMethod={selectedMethod}
            setSelectedMethod={setSelectedMethod}
          />
          {disableHeader && values.project != "" && values.roleId != "" && (
            <Row className="method-selection-style-container">
              <Col className="custom-control custom-radio" md="4">
                <input
                  type="radio"
                  className="custom-control-input"
                  id={"selectedMethod-tempateList"}
                  checked={selectedMethod == "templateList"}
                  name="selectedMethod"
                  onChange={(e) => handleSelectChannelToTest("templateList")}
                />
                <label
                  for={"selectedMethod-tempateList"}
                  className="custom-control-label channelLabel"
                >
                  Choose From Template List
                </label>
              </Col>
              <Col className="custom-control custom-radio" md="4">
                <input
                  type="radio"
                  className="custom-control-input"
                  id={"selectedMethod-existingRole"}
                  checked={selectedMethod == "existingRole"}
                  name="selectedMethod"
                  onChange={(e) => handleSelectChannelToTest("existingRole")}
                />
                <label
                  for={"selectedMethod-existingRole"}
                  className="custom-control-label channelLabel"
                >
                  Clone Templates Of Exiting Roles
                </label>
              </Col>
            </Row>
          )}
        </Card>
      </Container>

      {selectedMethod == "existingRole" &&
      disableHeader &&
      values.project != "" &&
      values.roleId != "" ? (
        <>
          <Container fluid>
            <Card>
              <Row className="d-flex flex-row pt-3 pl-3">
                <Col md="4">
                  <CommonInput
                    type={"multiSelectWithCheckboxes"}
                    // forTable={true}
                    id="notification-role"
                    placeHolder={"Select Existing Role"}
                    defaultValue={existingRoles}
                    data={roleData?.data}
                    onChange={(value) => {
                      setExistingRoles(value);
                    }}
                    loading={roleData?.fetching}
                    onFocus={handleExistingRoleSelectOnFocus}
                  />
                </Col>
                <Col
                  sm={{
                    offset: 5,
                    size: 3,
                  }}
                  md={{
                    offset: 5,
                    size: 3,
                  }}
                >
                  <CustomButton
                    permissionSet={["C", "U"]}
                    permissionType={"C,U"}
                    content={"Preview"}
                    disabled={existingRoles.length <= 0}
                    onClick={() => viewExistingRolesData(existingRoles)}
                  />
                  <CustomButton
                    permissionSet={["C", "U"]}
                    permissionType={"C,U"}
                    content={"Save"}
                    disabled={existingRoles.length <= 0}
                    onClick={() => saveExistingRolesData(existingRoles)}
                  />
                </Col>
              </Row>
            </Card>
            {disableHeader && rolesIds && rolesIds.length ? (
              <>
                <TemplateListingView
                  isViewOnly={false}
                  serverData={serverData}
                  setServerData={setServerData}
                  pagination={pagination}
                  setpagination={setpagination}
                  tableData={tableData}
                  setTableData={setTableData}
                  messageTemplateList={messageTemplateList}
                  setMessageTemplateList={setMessageTemplateList}
                  roleId={rolesIds}
                  searchParams={searchParams}
                  setSearchParms={setSearchParms}
                  setHavePreviousRecord={setHavePreviousRecord}
                  havePreviousRecord={havePreviousRecord}
                />
              </>
            ) : null}
          </Container>
        </>
      ) : (
        <></>
      )}

      {!disableHeader && values.roleId?.value && (
        <Container className="mt 1" fluid>
          <TemplateListingView
            isViewOnly={true}
            serverData={serverData}
            setServerData={setServerData}
            pagination={pagination}
            setpagination={setpagination}
            tableData={tableData}
            setTableData={setTableData}
            messageTemplateList={messageTemplateList}
            setMessageTemplateList={setMessageTemplateList}
            roleId={values.roleId?.value}
            searchParams={searchParams}
            setSearchParms={setSearchParms}
            setHavePreviousRecord={setHavePreviousRecord}
            havePreviousRecord={havePreviousRecord}
          />
        </Container>
      )}

      {disableHeader && selectedMethod != "existingRole" && (
        <>
          {" "}
          <TemplateListing
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            isAllSelected={isAllSelected}
            setAllSelected={setAllSelected}
            deselectedIds={deselectedIds}
            setDeselectedIs={setDeselectedIs}
            isSaving={isSaving}
            searchParams={searchParams}
            setSearchParms={setSearchParms}
          />
          <Container fluid>
            <Row className="d-flex justify-content-end mr-3">
              <CustomButton
                permissionSet={["C", "U"]}
                permissionType={"C,U"}
                content={"Reset"}
                onClick={reset}
              />
              <CustomButton
                permissionSet={["C", "U"]}
                permissionType={"C,U"}
                content={
                  isSaving ? (
                    <i className="fas fa-spinner fa-spin" aria-hidden="true" />
                  ) : (
                    "Save"
                  )
                }
                onClick={handleMapping}
              />
            </Row>
          </Container>
        </>
      )}
    </>
  );
};

export default TemplateMapping;
